import React from 'react';
import _ from 'lodash';

import {
  LabelledText,
  OverallOrderStatusChip
} from 'modules/layer00';
import {
  Box,
  Button,
  Chip,
  ChipTypeMap,
  Stack,
  styled,
  Typography
} from '@mui/material';
import {
  BaseWidget,
  PermissionWall
} from 'modules/layer01';

import * as dataService from './dataService';



const CustomerViewButtonBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(1)
}));



const OrderStatusBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export interface IProps {
  orderId: string;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.orderId);



  return (
    <BaseWidget.FC title="Order Source Information">
      <LabelledText.FC
        title="Order Number"
        text={queryTuple.data.orderNumber} />

      <Stack alignItems="flex-start">
        {queryTuple.data.urlToE1 && (
          <PermissionWall.FC requiresPermissions={['salesOrder_viewE1Link']}>
            <Button
              target="_blank"
              href={queryTuple.data.urlToE1}>
              View in E1
            </Button>
          </PermissionWall.FC>
        )}

        {queryTuple.data.urlToStore && (
          <PermissionWall.FC requiresPermissions={['salesOrder_viewStoreLink']}>
            <Button
              target="_blank"
              href={queryTuple.data.urlToStore}>
              View in Store
            </Button>
          </PermissionWall.FC>
        )}

        {queryTuple.data.urlToNetSuite && (
          <Button
            target="_blank"
            href={queryTuple.data.urlToNetSuite}>
            View in NetSuite
          </Button>
        )}
      </Stack>

      <LabelledText.FC
        title="Order Source"
        text={queryTuple.data.orderSourceDisplayName} />

      <LabelledText.FC
        title="Payment Status"
        text={(
          <Chip
            color={__paymentStatus2Color[queryTuple.data.paymentStatusName]}
            label={_.upperFirst(queryTuple.data.paymentStatusName)} />
        )} />

      <OrderStatusBox>
        <Typography variant="h2">
          Status
        </Typography>

        <OverallOrderStatusChip.FC
          label={queryTuple.data.overallOrderStatusDisplayName}
          statusName={queryTuple.data.overallOrderStatusName} />
      </OrderStatusBox>

      <CustomerViewButtonBox>
        {queryTuple.data.isSuperAdmin && (
          <Button
            target="_blank"
            href={queryTuple.data.urlToCustomerOrderDetail}>
            Customer View
          </Button>
        )}
      </CustomerViewButtonBox>
    </BaseWidget.FC>
  );
};



const __paymentStatus2Color: Record<dataService.IPaymentStatus, ChipTypeMap['props']['color']> = {
  cancelled: 'error',
  completed: 'success',
  failed: 'error',
  pending: 'info'
};
